<div class="complex-list-loading">
  @for (item of loadingItems; track item) {
    <div class="complex-list-loading__item" [ngClass]="'complex-list-loading__item--' + loadingSize">
      <div class="complex-list-loading__image" [ngClass]="'complex-list-loading__image--' + loadingSize"></div>
    </div>
  }
</div>
